import axios from 'axios';
import type { State } from '../types';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Game API
export const gameAPI = {
  getAllStates: async (geographyType?: string): Promise<{ states: State[] }> => {
    const params = geographyType ? { geography_type: geographyType } : {};
    const response = await api.get('/game/states', { params });
    return response.data;
  },

  getStateById: async (id: number): Promise<{ state: State }> => {
    const response = await api.get(`/game/states/${id}`);
    return response.data;
  },

  getStatesByRegion: async (region: string): Promise<{ states: State[] }> => {
    const response = await api.get(`/game/regions/${region}`);
    return response.data;
  }
};

export default api;
